import { render } from "./ComplementaryDataInput.vue?vue&type=template&id=d88361b4"
import script from "./ComplementaryDataInput.vue?vue&type=script&lang=js"
export * from "./ComplementaryDataInput.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__